import MobileDetect from 'mobile-detect';

const md = new MobileDetect(window.navigator.userAgent);

const isMobile = md.mobile();
const isTablet = md.tablet();
const isDesktop = !isMobile && !isTablet;

export { isMobile, isTablet, isDesktop };
